import service from "@/utils/request"

export function getTravelListApi(data) {
    return service({
        url: '/travel/getTravelList',
        method: 'get',
        params: data
    })
}
export function getTravelListCountApi(data) {
    return service({
        url: '/travel/getTravelCount',
        method: 'get',
        params: data
    })
}
export function getSjGoodsListBySpuIdApi(data) {
    return service({
        url: '/sjGoods/getSjGoodsListBySpuId',
        method: 'get',
        params: data
    })
}
//获取商品详情
export function getTravelDetailById(data) {
    return service({
        url: '/travel/getTravelDetailById',
        method: 'get',
        params: data
    })
}

//保存商品
export function saveTravelApi(data) {
    return service({
        url: '/travel',
        method: 'post',
        data
    })
}
//获取商品详情
export function getGoodsInfoApi(data) {
    return service({
        url: '/sjGoods/echo',
        method: 'get',
        params: data
    })
}
//导出文件
export function getExportTravelListApi(data) {
    return service({
        url: '/travel/getExportTravelList',
        method: 'get',
        params: data,
        responseType: 'blob',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    })
}
//上架小助手
export function getGoodsAssistantApi(data) {
    return service({
        url: '/sjGoods/goodsAssistant',
        method: 'post',
        data,
    })
}

export function updateTravelPriceApi(data) {
    return service({
        url: '/travel/updatePrice',
        method: 'put',
        data,
    })
}

export function updateTravelDepositApi(data) {
    return service({
        url: '/travel/updateDeposit',
        method: 'put',
        data,
    })
}

export function updateTravelSortNumApi(data) {
    return service({
        url: '/travel/updateSortNum',
        method: 'put',
        data,
    })
}

export function updateIsQuanApi(data) {
    return service({
        url: '/sjGoods/updateIsQuan',
        method: 'put',
        data,
    })
}

export function updatePoolPriceApi(data) {
    return service({
        url: '/sjGoods/updatePoolPrice',
        method: 'put',
        data,
    })
}

export function updateSjGoodsSalePriceApi(data) {
    return service({
        url: '/sjGoods/updateSalePrice',
        method: 'put',
        data,
    })
}
//修改库存
export function updateStockApi(data) {
    return service({
        url: '/sjGoods/updateStock',
        method: 'put',
        data,
    })
}
// 更新状态
export function updateIsShowApi(data) {
    return service({
        url: '/travel/updateBatchIsShow',
        method: 'put',
        data,
    })
}

export function updateBatchSevenNrrApi(data) {
    return service({
        url: '/sjGoods/updateBatchSevenNrr',
        method: 'put',
        data,
    })
}
export function updateBatchFreightApi(data) {
    return service({
        url: '/sjGoods/updateBatchFreight',
        method: 'put',
        data,
    })
}

export function selectionGoodsApi(data) {
   /* return service({
        url: '/sjGoods/pushAllByIsShow',
        method: 'post',
        data
    })*/

    return service({
        url: '/chooseGoods/selectionGoods',
        method: 'post',
        data
    })
}

export function getReviewedTravelCountApi(data) {
    return service({
        url: '/chooseTravelManagement/getReviewedTravelCount',
        method: 'get',
        params: data
    })
}

export function getReviewedTravelListApi(data) {
    return service({
        url: '/chooseTravelManagement/getReviewedTravelList',
        method: 'get',
        params: data
    })
}

export function getReviewedPoolGoodsListApi(data) {
    return service({
        url: '/chooseGoodsManagement/getReviewedPoolGoodsList',
        method: 'get',
        params: data
    })
}

export function getReviewedPoolGoodsCountApi(data) {
    return service({
        url: '/chooseGoodsManagement/getReviewedPoolGoodsCount',
        method: 'get',
        params: data
    })
}

export function getStaffListApi() {
    return service({
        url: '/category/getStaffList',
        method: 'get'
    })
}

export function unSelectedGoodsApi(data) {
    return service({
        url: '/travel/unSelectedGoods',
        method: 'get',
        params: data
    })
}

export function unSelectedPoolGoodsApi(data) {
    return service({
        url: '/sjGoods/unSelectedPoolGoods',
        method: 'get',
        params:data
    })
}

export function unSelectedPoolGoodsCountApi(data) {
    return service({
        url: '/sjGoods/unSelectedPoolGoodsCount',
        method: 'get',
        params: data
    })
}

export function updateGoodsInfoOfSecondaryOperatorsApi(data) {
    return service({
        url: '/sjGoods/updateSecondaryGoodsInfo',
        method: 'put',
        data
    })
}
